import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { candidateService } from '../services/candidate.service';
import type { Candidate, CandidateStatus } from '../types/candidate.types';

interface UpdateStatusParams {
  id: string;
  status: CandidateStatus;
}

export function useUpdateCandidateStatus(): {
  updateStatus: UseMutateFunction<Candidate, Error, UpdateStatusParams>;
  updateStatusAsync: (params: UpdateStatusParams) => Promise<unknown>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, status }: UpdateStatusParams) =>
      candidateService.updateCandidateStatus(id, { status }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['candidates'] });
      queryClient.invalidateQueries({ queryKey: ['candidate', variables.id] });
    },
  });

  return {
    updateStatus: mutation.mutate,
    updateStatusAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
